"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var defaultGridContext = {
    state: {
        data: [],
        headerHeight: 0,
        resizable: false,
        toggleable: false,
        pagination: undefined,
        scrollbarWidth: 0,
        hasVerticalScroll: false,
        availableRowsHeight: 0,
        disabled: false,
        isLoading: false,
        rowHeight: 0,
        selection: undefined,
        hideHeader: false,
        sort: undefined,
        totalRow: {},
        initialScrollTop: 0,
        height: 0,
        layoutWidth: 0,
        isEmpty: false,
        columns: [],
        defaultColumnWidth: 0,
        columnsWidth: {}
    },
    onRowClick: function () { },
    onRowDoubleClick: function () { },
    onRowContextMenu: function () { },
    onSelectionChange: function () { },
    onHeaderSelectionChange: function () { },
    onScroll: function () { },
    onRowSelect: function () { },
    updateResizedColumns: function () { }
};
exports.GridContext = react_1.default.createContext(defaultGridContext);
exports.useGridContext = function () { return react_1.useContext(exports.GridContext); };
var GridProvider = /** @class */ (function (_super) {
    __extends(GridProvider, _super);
    function GridProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.updateResizedColumns = function (column) {
            _this.setState(function (state) { return Object.assign({}, state, column); });
        };
        _this.state = {
            resizedColumn: {}
        };
        return _this;
    }
    GridProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, onRowClick = _a.onRowClick, onRowDoubleClick = _a.onRowDoubleClick, onRowContextMenu = _a.onRowContextMenu, onSelectionChange = _a.onSelectionChange, onHeaderSelectionChange = _a.onHeaderSelectionChange, onScroll = _a.onScroll, columnsWidth = _a.columnsWidth, onColumnResize = _a.onColumnResize, restProps = __rest(_a, ["children", "onRowClick", "onRowDoubleClick", "onRowContextMenu", "onSelectionChange", "onHeaderSelectionChange", "onScroll", "columnsWidth", "onColumnResize"]);
        var onRowSelect = function () { };
        var ctx = {
            state: __assign(__assign({}, restProps), { columnsWidth: Object.assign({}, columnsWidth, this.state) }),
            onRowClick: onRowClick,
            onRowDoubleClick: onRowDoubleClick,
            onRowContextMenu: onRowContextMenu,
            onSelectionChange: onSelectionChange,
            onHeaderSelectionChange: onHeaderSelectionChange,
            onScroll: onScroll,
            onRowSelect: onRowSelect,
            updateResizedColumns: this.updateResizedColumns
        };
        return (react_1.default.createElement(exports.GridContext.Provider, { value: Object.assign({}, defaultGridContext, ctx) }, children));
    };
    return GridProvider;
}(react_1.default.Component));
exports.default = GridProvider;
//# sourceMappingURL=GridProvider.js.map